import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { api } from '../../api/client';
import type { PaymentRequestListItem } from '@pay/shared';
import { Money } from '../../components/Money';
import { StatusBadge } from '../../components/StatusBadge';

export default function Requests() {
  const [rows, setRows] = useState<PaymentRequestListItem[]>([]);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');

  function load() {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (status) params.set('status', status);
    params.set('limit', '200');
    api.get<PaymentRequestListItem[]>(`/api/admin/requests?${params}`).then(setRows).catch(() => {});
  }
  useEffect(load, []);

  return (
    <div className="p-6 max-w-6xl">
      <h1 className="text-2xl font-semibold mb-6">Krav</h1>

      <div className="bg-white rounded-lg shadow border border-slate-200 p-4 mb-5 flex items-center gap-3">
        <div className="flex-1 relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && load()}
            placeholder="Søk referanse, navn eller e-post …"
            className="w-full border border-slate-300 rounded pl-10 pr-3 py-2 text-sm"
          />
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-slate-300 rounded px-3 py-2 text-sm">
          <option value="">Alle statuser</option>
          <option value="PENDING">Venter</option>
          <option value="AUTHORIZED">Autorisert</option>
          <option value="CAPTURED">Betalt</option>
          <option value="ABORTED">Avbrutt</option>
          <option value="EXPIRED">Utløpt</option>
          <option value="FAILED">Feilet</option>
          <option value="REFUNDED">Refundert</option>
        </select>
        <button onClick={load} className="bg-brand hover:bg-brand-dark text-white rounded px-3 py-2 text-sm font-medium">
          Søk
        </button>
      </div>

      <div className="bg-white rounded-lg shadow border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-xs uppercase">
            <tr>
              <th className="text-left px-6 py-3">Opprettet</th>
              <th className="text-left px-6 py-3">Eier</th>
              <th className="text-left px-6 py-3">Referanse</th>
              <th className="text-left px-6 py-3">Kunde</th>
              <th className="text-right px-6 py-3">Beløp</th>
              <th className="text-left px-6 py-3">Flyt</th>
              <th className="text-left px-6 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-6 py-3 text-slate-600">{new Date(r.created_at).toLocaleString('nb-NO')}</td>
                <td className="px-6 py-3">{r.owner_name}</td>
                <td className="px-6 py-3 font-mono text-xs">
                  <Link to={`/admin/requests/${r.id}`} className="text-brand hover:underline">
                    {r.external_reference}
                  </Link>
                </td>
                <td className="px-6 py-3">{r.customer_name}</td>
                <td className="px-6 py-3 text-right"><Money ore={r.amount_ore} /></td>
                <td className="px-6 py-3">{r.flow}</td>
                <td className="px-6 py-3"><StatusBadge status={r.status} /></td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={7} className="px-6 py-8 text-center text-slate-500">
                  Ingen krav matcher.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
